import { Injectable } from '@angular/core';
import { SnackbarTypes } from '../_enums/snackbar.types';
import { Favorite } from '../_models/favorite';
import { FavoriteService } from '../_services/favorite.service';
import { SnackbarService } from '../_services/snackbar.service';

export function normalizeSearchText(text: string | undefined | null): string {
  if (!text) return '';
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  constructor(
    private favoriteService: FavoriteService,
    private snackbarService: SnackbarService
  ) {}

  // Gestion des favoris

  async addToFavorite(resourceId: string) {
    let favorite = <Favorite>{ resourceId: resourceId };

    let resp = await this.favoriteService.add(favorite);

    if (resp) {
      this.snackbarService.open(SnackbarTypes.addFavorite);
    }
    return resp.userFavoriteId;
  }

  async getFavoriteIdForResource(resourceId: string) {
    return this.favoriteService.getFavoriteByResourceId(resourceId);
  }

  async removeFromFavorite(favoriteId: string) {
    await this.favoriteService.delete(favoriteId);
    this.snackbarService.open(SnackbarTypes.deleteFavorite);
  }
}
